/* eslint-disable global-require */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { getAppTheme } from '@/features/common/helpers/whiteLabel';
import { AppTheme } from './features/common/constants';

const theme = getAppTheme();

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',

  messages: {
    en: require('@/locales/en.json'),
  },
});

if (theme !== AppTheme.Default) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  i18n.mergeLocaleMessage('en', require(`@/locales/${theme}/en.json`));
}

export default i18n;
